import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button } from "primereact/button";
import { useHistory, useLocation } from "react-router-dom";
import { handleGetRequest } from "../../services/GetTemplate";
import styles from "../billing/invoiceDetail.module.scss";
import { Tooltip } from "react-tippy";
import { toast } from "react-toastify";
import Water from "../common/WaterMark";
import generatePDF from "react-to-pdf";
import { Dialog } from "primereact/dialog";
import PaymentModel from "./PaymentModel";

function Invoice() {
    const targetRef = useRef();
    const history = useHistory();
    const [brands, setBrands] = useState();
    const [packages, setPackages] = useState([]);
    const [oversize, setOversize] = useState(0);
    const [dangerous, setDangerous] = useState(0);
    const [custom, setCustom] = useState(0);
    const [total, setTotal] = useState(0);
    const [loyalty, setLoyalty] = useState(0);
    const [pickup, setPickup] = useState(0);
    const [packaging, setPackaging] = useState(0);
    const [declaration, setDeclaration] = useState(0);
    const [fullTotal, setFullTotal] = useState(0);
    const [paid, setPaid] = useState(false);
    const [show, setShow] = useState(false);
    const [notpaid, setNotPaid] = useState(false);
    const [notes, setNotes] = useState();
    const [SubTotal, setSubTotal] = useState(0);
    const [discountedAmount, setDiscountedAmount] = useState(0);
    const [monthly, setMonthly] = useState(0);
    const [website, setWebsite] = useState(0);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id");
    const getBrands = async () => {
        const res = await handleGetRequest("/specificInvoice/" + id);
        setBrands(res?.data);
        setPackages(res?.data?.packages);
        setOversize(res?.data?.oversizeFee);
        setDangerous(res?.data?.dangerousItemFee);
        setCustom(res?.data?.customDuties);
        setTotal(res?.data?.invoiceAmount);
        setFullTotal(res?.data?.invoiceAmount);
        setLoyalty(res?.data?.loyaltyDiscount);
        setPickup(res?.data?.pickupFee);
        setPackaging(res?.data?.packagingFee);
        setDeclaration(res?.data?.declarationFee);
        setNotes(res?.data?.notes);
        setSubTotal(res?.data?.TotalAmount);
        setDiscountedAmount(res?.data?.discountedAmount);
        setMonthly(res?.data?.MonthlyFee);
        setWebsite(res?.data?.WebsiteFee);
        if (res?.data?.paymentStatus === "paid") {
            setPaid(true);
            setShow(false);
        }
    };
    useMemo(() => {
        getBrands();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const handleMonthly = (e) => {
        setMonthly(parseInt(e));
        const total = parseInt(e) + website;
        setTotal(total);
    };

    const handleWebsite = (e) => {
        setWebsite(parseInt(e));
        const total = monthly + parseInt(e);
        setTotal(total);
    };

    const handlePdf = () => {
        if (brands?.paymentStatus === "paid") {
            generatePDF(targetRef, {
                filename: `inovice(${brands?.invoiceNo}).pdf`,
                page: {
                    format: "A3",
                    margin: {
                        top: 10,
                        right: 30,
                        bottom: 10,
                        left: 30,
                    },
                },
            });
        } else {
            setShow(false);
            setNotPaid(true);
        }
    };

    useEffect(() => {
        if (show === false && notpaid === true) {
            generatePDF(targetRef, {
                filename: "notPaid.pdf",
                page: {
                    format: "A3",
                    margin: {
                        top: 10,
                        right: 30,
                        bottom: 10,
                        left: 30,
                    },
                },
            });
            setShow(true);
            setNotPaid(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    const [showDialog, setShowDialog] = useState(false);

    const onHideTyreBrandsDialog = () => {
        setShowDialog(false);
    };

    const onsuccess = () => {
        onHideTyreBrandsDialog();
        toast.success("Payment Made.");
        window.location.reload();
    };

    const handlePayment = () => {
        localStorage.setItem("invoiceId", brands?._id);
        localStorage.setItem("PaymentUser", "user");
        history.push(`/payment`);
    };

    // An additional invoice's entire content is its own additionalCharges
    // list (rendered separately below) - the flat fields below are only a
    // report-compatibility mirror of those same amounts, so showing both
    // here would double up every charge under two different labels. It also
    // never represents real shipped weight, so none of the package/weight
    // rendering applies to it either.
    const isAdditional = brands?.invoiceCategory === "additional";

    // Goods bought for the client: shown as its own items list, with every
    // shipping-specific row (weight, per-pound price, add-ons) hidden.
    const isPurchase = brands?.invoiceCategory === "purchase";
    const hideShipping = isAdditional || isPurchase;

    // Same set of add-on fees as the admin invoice page, read directly from
    // the fetched invoice (this page is read-only - clients never edit these).
    const feeRows =
        brands?.invoiceType !== "Monthly" && !hideShipping
            ? [
                  { key: "price", label: "Cost of Goods", value: brands?.itemsPrice },
                  { key: "oversize", label: brands?.type === "sea" ? "Handling" : "Oversize Fee", value: brands?.oversizeFee },
                  { key: "packaging", label: "Packaging", value: brands?.packagingFee },
                  { key: "pickup", label: "Pickup", value: brands?.pickupFee },
                  { key: "delivery", label: "Delivery", value: brands?.deliveryFee },
                  { key: "handling", label: "Handling", value: brands?.handling },
                  { key: "insurance", label: "Insurance", value: brands?.insurance },
                  { key: "declaration", label: brands?.type === "sea" ? "Pre-Clearance" : "Declaration Fee", value: brands?.declarationFee },
                  { key: "custom", label: "Custom Duties", value: brands?.customDuties },
                  { key: "dangerous", label: "Dangerous Item Fee", value: brands?.dangerousItemFee },
              ]
            : [];

    const hasAnyAddOn = feeRows.some((row) => row.value !== 0);

    const statusMeta = brands?.paymentStatus === "paid" ? { label: "Paid", cls: styles.paid } : brands?.paidAmount > 0 ? { label: "Partially Paid", cls: styles.partial } : { label: "Pending", cls: styles.pending };

    return (
        <>
            <Dialog visible={showDialog} header="Pay Invoice" style={{ width: "650px" }} onHide={() => setShowDialog(false)}>
                <PaymentModel onHideTyreBrandsDialog={onHideTyreBrandsDialog} onsuccess={onsuccess} />
            </Dialog>

            <div className={styles.pageContainer}>
                <div className={styles.toolbar}>
                    <div className={styles.toolbarLeft}>
                        <span className={styles.invoiceNo}>Invoice #{brands?.invoiceId}</span>
                        <span className={`${styles.statusBadge} ${statusMeta.cls}`}>{statusMeta.label}</span>
                    </div>
                    <div className={styles.toolbarActions}>
                        <Tooltip title="Download Invoice as PDF" position="bottom" trigger="mouseenter" arrow={true}>
                            <Button icon="pi pi-file-pdf" label="PDF" className={styles.actionBtn} onClick={handlePdf} />
                        </Tooltip>
                        {!paid && (
                            <Tooltip title="Pay Invoice" position="bottom" trigger="mouseenter" arrow={true}>
                                <Button icon="pi pi-wallet" label="Pay" className={`${styles.actionBtn} ${styles.actionBtnPrimary}`} onClick={() => handlePayment()} />
                            </Tooltip>
                        )}
                    </div>
                </div>

                <div className={styles.layout}>
                    <div className={styles.documentColumn}>
                        <div className={styles.documentOuter} ref={targetRef}>
                            {paid && <Water />}
                            <div className={styles.paper}>
                                <div className={styles.docHeader}>
                                    <img src={"https://res.cloudinary.com/dwxqg9so3/image/upload/w_500,q_auto:best,f_auto,dpr_2.0/v1758208458/4wd_logo_white_duzzog.png"} className={styles.logo} alt="logo" />
                                    <div className={styles.infoGrid}>
                                        <div className={styles.infoBlock}>
                                            <h4>Client Info</h4>
                                            <span>{brands?.clientName}</span>
                                            <span>{brands?.email}</span>
                                            <span>{brands?.phone}</span>
                                        </div>
                                        <div className={styles.infoBlock}>
                                            <h4>Shipping Address</h4>
                                            <p>1470 Lee Wagener Blvd, 101</p>
                                            <p>Fort Lauderdale</p>
                                            <p>FL 33315</p>
                                        </div>
                                    </div>
                                </div>

                                <div className={styles.docTitleRow}>
                                    <h2 className={styles.docTitle}>{paid ? "Receipt" : "Invoice"}</h2>
                                </div>

                                <div className={styles.metaList}>
                                    <div className={styles.metaRow}>
                                        <span className={styles.metaLabel}>Order Date</span>
                                        <span className={styles.metaValue}>{brands?.date}</span>
                                    </div>
                                    <div className={styles.metaRow}>
                                        <span className={styles.metaLabel}>Payment Method</span>
                                        <span className={styles.metaValue}>Card {brands?.datePaid ? `at ${brands?.datePaid}` : null}</span>
                                    </div>
                                    {!hideShipping && (
                                        <div className={styles.metaRow}>
                                            <span className={styles.metaLabel}>Total {brands?.type === "sea" ? "Size" : "Weight"}</span>
                                            <span className={styles.metaValue}>
                                                {brands?.weight} {brands?.type === "sea" ? "Cu ft" : "Lbs"}
                                            </span>
                                        </div>
                                    )}
                                    <div className={styles.metaRow}>
                                        <span className={styles.metaLabel}>Contents</span>
                                        <span className={styles.metaValue}>{brands?.descriptions}</span>
                                    </div>
                                </div>

                                <table className={styles.table}>
                                    <thead>
                                        <tr>
                                            <th>{isPurchase ? "Item" : hideShipping ? "Description" : "Product"}</th>
                                            <th>{isPurchase ? "Qty" : hideShipping ? "" : brands?.type === "sea" ? "Size" : "Weight"}</th>
                                            <th>{isPurchase ? "Unit Price" : hideShipping ? "" : "Price"}</th>
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isAdditional &&
                                            brands?.additionalCharges?.map((charge, index) => (
                                                <tr className={styles.row} key={index}>
                                                    <td>{charge.label}</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>${Number(charge.amount).toFixed(2)}</td>
                                                </tr>
                                            ))}

                                        {isPurchase &&
                                            brands?.purchase?.items?.map((item, index) => (
                                                <tr className={styles.row} key={index}>
                                                    <td>
                                                        {item.url ? (
                                                            <a href={item.url} target="_blank" rel="noopener noreferrer">
                                                                {item.description}
                                                            </a>
                                                        ) : (
                                                            item.description
                                                        )}
                                                    </td>
                                                    <td>{item.quantity}</td>
                                                    <td>${Number(item.unitPrice).toFixed(2)}</td>
                                                    <td>${(Number(item.quantity) * Number(item.unitPrice)).toFixed(2)}</td>
                                                </tr>
                                            ))}

                                        {isPurchase && Number(brands?.purchase?.shipping) > 0 && (
                                            <tr className={styles.row}>
                                                <td>Merchant Shipping</td>
                                                <td></td>
                                                <td></td>
                                                <td>${Number(brands.purchase.shipping).toFixed(2)}</td>
                                            </tr>
                                        )}
                                        {isPurchase && Number(brands?.purchase?.tax) > 0 && (
                                            <tr className={styles.row}>
                                                <td>Tax</td>
                                                <td></td>
                                                <td></td>
                                                <td>${Number(brands.purchase.tax).toFixed(2)}</td>
                                            </tr>
                                        )}

                                        {brands?.invoiceType !== "Monthly" &&
                                            !hideShipping &&
                                            packages?.map((item, index) => {
                                                let temp;
                                                let prev = packages[index - 1]?.product;
                                                if (brands?.customerType === "client") {
                                                    if (brands?.size === "sea") {
                                                        temp = "Total Size of Cargo";
                                                    } else {
                                                        if (item?.product === prev) {
                                                            temp = "Additional Pounds";
                                                        } else {
                                                            temp = "1st Pound of Cargo";
                                                        }
                                                    }
                                                } else {
                                                    if (brands?.type === "sea") {
                                                        temp = "Total Size of Cargo";
                                                    } else {
                                                        temp = "Total Pounds of Cargo";
                                                    }
                                                }
                                                return (
                                                    <tr className={styles.row} key={item?._id || index}>
                                                        <td>{temp}</td>
                                                        <td>
                                                            {item?.weight} {item?.type === "sea" ? "cu" : "lb"}
                                                        </td>
                                                        <td>${item?.price}</td>
                                                        <td>${(item?.total).toFixed(2)}</td>
                                                    </tr>
                                                );
                                            })}

                                        {hasAnyAddOn && (
                                            <tr className={styles.row}>
                                                <td className={styles.addOnLabelCell} style={{ fontWeight: 600 }}>
                                                    Add-ons
                                                </td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                        )}

                                        {feeRows.map(
                                            (row) =>
                                                row.value !== 0 && (
                                                    <tr className={styles.row} key={row.key}>
                                                        <td className={styles.addOnLabelCell}>{row.label}</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>${row.value}</td>
                                                    </tr>
                                                ),
                                        )}

                                        {brands?.invoiceType === "Monthly" && !hideShipping && (
                                            <tr className={styles.row}>
                                                <td>Monthly Fee</td>
                                                <td></td>
                                                <td></td>
                                                <td>${brands?.MonthlyFee}</td>
                                            </tr>
                                        )}
                                        {brands?.invoiceType === "Monthly" && !hideShipping && (
                                            <tr className={styles.row}>
                                                <td>Website usage Fee</td>
                                                <td></td>
                                                <td></td>
                                                <td>${brands?.WebsiteFee}</td>
                                            </tr>
                                        )}

                                        <tr className={`${styles.row} ${styles.subtotalRow}`}>
                                            <td>Sub-Total</td>
                                            <td></td>
                                            <td></td>
                                            <td>${brands?.customerType === "partner" || brands?.customerType === "admin" ? (SubTotal).toFixed(2) : (total).toFixed(2)}</td>
                                        </tr>
                                        {brands?.customerType === "partner" ||
                                            (brands?.customerType === "admin" && (
                                                <tr className={styles.row}>
                                                    <td>{brands?.customerType === "partner" ? "Credit Discount" : "Admin Discount"}</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>- ${brands?.discountedAmount}</td>
                                                </tr>
                                            ))}

                                        <tr className={styles.row}>
                                            <td>Tax</td>
                                            <td></td>
                                            <td></td>
                                            <td>$0</td>
                                        </tr>

                                        {brands?.paymentStatus === "pending" && !(brands?.paidAmount > 0) && (
                                            <tr className={`${styles.row} ${styles.totalRow}`}>
                                                <td>Total</td>
                                                <td></td>
                                                <td></td>
                                                <td>${(brands?.invoiceAmount).toFixed(2)}</td>
                                            </tr>
                                        )}
                                        {brands?.paymentStatus === "pending" && brands?.paidAmount > 0 && (
                                            <>
                                                <tr className={styles.row}>
                                                    <td>Paid Amount</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>${(brands?.paidAmount).toFixed(2)}</td>
                                                </tr>
                                                <tr className={`${styles.row} ${styles.totalRow}`}>
                                                    <td>Remaining Amount</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>${(brands?.invoiceAmount).toFixed(2)}</td>
                                                </tr>
                                            </>
                                        )}
                                        {brands?.paymentStatus === "paid" && (
                                            <tr className={`${styles.row} ${styles.totalRow}`}>
                                                <td>Total</td>
                                                <td></td>
                                                <td></td>
                                                <td>${(brands?.paidAmount).toFixed(2)}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                <div className={styles.notesSection}>
                                    <p className={styles.notesTitle}>Customer Note</p>
                                    <p className={styles.notesIntro}>THANK YOU for choosing MOVE4WD as your shipping partner! Please see your order updates below.</p>
                                    <ul className={styles.notesList}>
                                        <li>Status: Preparing Package for Shipment</li>
                                        <li>Shipment: {brands?.shipmentNumber}</li>
                                        <li>Package: {brands?.Waybills}</li>
                                        {notes && <li>Notes: {notes}</li>}
                                    </ul>
                                    <p className={styles.zipNote}> PLEASE USE 00000 for the ZIP Code when using a Jamaican Debit/Credit Card) to make payment.</p>

                                    <img
                                        src="https://res.cloudinary.com/dwxqg9so3/image/upload/v1696375833/WhatsApp_Image_2023-09-25_at_03.12.56_463150e6_ua2zka.jpg"
                                        className={styles.whatsappBanner}
                                        onClick={() => handlePayment()}
                                        alt="Pay via WhatsApp"
                                    />
                                    <p className={styles.footerText}>
                                        <strong>MOVE4WD INC</strong> is a registered corporation in Florida, United States
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Invoice;
